<ion-content class="ion-padding">
  <usucampeao-projetos-detalhes-v2 [projeto]="projeto$ | async"></usucampeao-projetos-detalhes-v2>
</ion-content>
